import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { ChakraFAIcon } from "@/components/ui/Icon";

export interface WarningBannerProps {
	message: string | React.ReactNode;
	title?: string;
}

export function WarningBanner(props: WarningBannerProps): JSX.Element {
	return (
		<Box
			mb={4}
			p={4}
			borderRadius="6px"
			backgroundColor="var(--q-bg-warning-weak, #FFECC6)"
			border="1px solid var(--q-border-warning, #FDE68A)"
			minWidth={0}
			width="100%"
		>
			<Flex gap={3} align="flex-start" minWidth={0}>
				<Box flexShrink={0}>
					<ChakraFAIcon icon="fa-triangle-exclamation" variant="solid" color="var(--q-text-warning, #84560B)" boxSize={4} />
				</Box>
				<Box flex={1} minWidth={0}>
					{props.title && (
						<Text
							fontSize="14px"
							fontWeight={600}
							lineHeight="20px"
							color="var(--q-text-warning, #84560B)"
							fontFamily="Roboto, sans-serif"
							mb={2}
						>
							{props.title}
						</Text>
					)}
					<Text
						fontSize="14px"
						fontWeight={400}
						lineHeight="20px"
						color="var(--q-text-warning, #84560B)"
						fontFamily="Roboto, sans-serif"
						wordBreak="break-word"
						overflowWrap="break-word"
						whiteSpace="normal"
					>
						{props.message}
					</Text>
				</Box>
			</Flex>
		</Box>
	);
}
